<template>
  <div id="processmap">
      <!-- Process Map -->
      <div class="col-lg-12" style='overflow:scroll;'>
          <v-btn
            rounded
            small
            class="add-button"
            @click.stop="addProcessForm(standard.id)"
          >
              Add Process
          </v-btn>
          <div ref="container"/>
      </div>
      <!-- End of Process Map -->
      <v-dialog
        v-model="showEditProcessModal"
        scrollable
        persistent        
      >
        <v-card
          :loading="loading"
        >
          <v-card-title class="modal-card-title">
            <span  class="qmkey-modal-h1 pb-0">
              {{ edit_or_new }} PROCESS {{ edit_process.name }}
            </span>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="closeProcessForm"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="editProcess"
              v-model="addProcessValid"
              autocomplete="off"
            >
              <v-alert
                :value="alert"
                color="error"
                dark
                icon="mdi-alert"
                transition="scale-transition"
                outlined
                dismissible
              >
                {{ message }}
              </v-alert>
              <v-row >
                <v-col>
                  <v-text-field
                    name="reference"
                    label="Reference"
                    id="reference"
                    autofocus
                    placeholder="Enter Reference"
                    v-model="edit_process.reference"
                    :rules="[rules.required]"
                    class="'qmkey-form-input'"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    name="name"
                    label="Name"
                    id="name"
                    placeholder="Enter Name"
                    v-model="edit_process.name"
                    :rules="[rules.required]"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="process_types"
                    v-model="edit_process.process_type"
                    label="Process Type"
                    placeholder="Select Process type"
                    @change="onProcessTypeChange($event)" 
                    :required= "!process_type_read_only"
                    :readonly= "process_type_read_only"
                    class="'qmkey-form-input'"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="description"
                    label="Description"
                    name="description"
                    placeholder="Enter Process Description"
                    v-model="edit_process.description"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="entries"
                    label="Entries"
                    name="entries"
                    placeholder="Enter Entries"
                    v-model="edit_process.entries"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="outputs"
                    label="Outputs"
                    name="outputs"
                    placeholder="Enter Outputs"
                    v-model="edit_process.outputs"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="activities"
                    label="Activities"
                    name="activities"
                    placeholder="Enter Activities"
                    v-model="edit_process.activities"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="activities"
                    label="Process Object"
                    name="process_object"
                    placeholder="Enter Process Object"
                    v-model="edit_process.process_object"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    id="activities"
                    label="Scope"
                    name="scope"
                    placeholder="Enter Scope"
                    v-model="edit_process.scope"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="process_entries"
                    v-model="edit_process.process_entries"
                    label="Process Entries"
                    multiple
                    class="qmkey-form-input"
                    placeholder="Select Process Entries"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.responsible_roles"
                    placeholder="Roles that are responsibles of the Process"
                    label="Process Responsible Roles"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.creator_roles"
                    placeholder="Roles that can create BPs implementing the Process"
                    label="Process Creator Roles"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.editor_roles"
                    placeholder="Roles that can execute all transitions into QUnits implementing the Process"
                    label="Process Editor Roles"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.reader_roles"
                    placeholder="Roles that can read ALL BPs implementing the Process"
                    label="Process Reader Roles"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="qmkey-modal-dialog-card-actions">
            <v-spacer></v-spacer>
            <v-btn
              v-if="!process_type_read_only"
              class="qmkey-modal-dialog-button-submit"
              @click="addProcess"
              :disabled="!addProcessValid"
              small
            >
              Ok
            </v-btn>
            <v-btn
              v-if="process_type_read_only"
              class="qmkey-modal-dialog-button-submit"
              @click="editProcess"
              :disabled="!addProcessValid"
              small
            >
              OK Modify
            </v-btn>            
            <v-btn 
              small
              @click="clearEditProcess"
              class="qmkey-modal-dialog-button-secundary"
            >
              Clear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>      
      <!-- Edit Permissions Modal -->
      <v-dialog
        v-model="showProcessRoles"
        persistent 
        transition="dialog-transition"
        scrollable
      >
        <v-card>
          <v-card-title class="modal-card-title">
            EDIT PROCESS {{ edit_process.name }} ROLES
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="closeProcessPermissionsForm"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>            
          <v-card-text>
            <v-form
              ref="editProcessPermissions"
              v-model="editProcessPermissionsValid"
              autocomplete="off"
            >
              <v-alert
                :value="alertRoles"
                color="error"
                dark
                icon="mdi-alert"
                transition="scale-transition"
                outlined
                dismissible
              >
                {{ message }}
              </v-alert>
              <v-row>
                <v-col>
                  Permission ID
                </v-col>
                <v-col>
                  Roles Allowed          
                </v-col>
                <v-col>
                  Departments Allowed
                </v-col>
                <v-col>
                  Actions
                </v-col>
              </v-row>
              <v-row 
                v-for="permission in edit_process.qprocesspermission_set" 
                :key="permission.id"
              >
                <v-col>
                  <input type="hidden" v-model="permission.id" />
                  <v-text-field
                    name="permission_id"
                    id="permission_id"
                    v-model="permission.permission_id"
                    readonly
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-text-field>                  
                </v-col>
                <v-col>
                  <v-select
                    id="roles_allowed"
                    name="roles_allowed"
                    :items="allRoles"
                    v-model="permission.roles_allowed"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-select>                  
                </v-col>
                <v-col>
                  <v-select
                    id="departments_allowed"
                    name="departments_allowed"
                    :items="allDepartments"
                    v-model="permission.departments_allowed"                    
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn
                    class="btn-sm btn-danger qmkey-modal-dialog-button-secundary"
                    small
                    v-on:click="deletePermission(permission.id)"
                  >
                    Delete Role
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    name="permission_id"
                    id="permission_id"
                    v-model="newPermission.permission_id"
                    required
                    :rules="[validatePermissionId]"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-text-field>                  
                </v-col>
                <v-col>
                  <v-select
                    id="roles_allowed"
                    name="roles_allowed"
                    :items="allRoles"
                    v-model="newPermission.roles_allowed"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  >
                  </v-select>                  
                </v-col>
                <v-col>
                  <v-select
                    id="departments_allowed"
                    name="departments_allowed"
                    :items="allDepartments"
                    v-model="newPermission.departments_allowed"         
                    multiple
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn
                    class="qmkey-modal-dialog-button-submit"
                    text
                    v-on:click="addProcessPermission()"
                    :disabled="!validPermissionId"
                    small
                  >
                    Add Role
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="qmkey-modal-dialog-card-actions">
            <v-spacer></v-spacer>
            <v-btn
              class="qmkey-modal-dialog-button-submit"
              text
              @click="editProcess"
              small
            >
              Ok
            </v-btn>
            <v-btn
              class="qmkey-modal-dialog-button-secundary"
              small
              @click="closeProcessPermissionsForm"
              color="#FFFFFF"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>        
      </v-dialog>
      <!-- End of edit permissions modal -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Roles from '@/api/Roles'

import {
  mxGraph as MxGraph,
  mxConstants,
  mxUtils,
  mxSwimlaneManager,
  mxStackLayout,
  mxLayoutManager,
  mxEvent,
} from "mxgraph-js";

export default {
  name: "ProcessChart",
  props: {
    standard: { type: Object, required: true}
  },
  data: function() {
    return {
      edit_process: {},
      allRoles: [],
      allDepartments: [],
      message: null,
      aspects: [],
      newAspect: {},
      current_standard_aspects: [],
      processes: [],
      graph: null,
      parent: null,
      graph_standard: null,
      graph_estrategico: null,
      graph_clave: null,
      graph_deapoyo: null,
      currentProcess: {},
      edit_process: {},
      newPermission: {},
      process_entries: [],
      process_types: [
        {
          text: 'Clave',
          value: 'C'
        },
        {
          value: 'E',
          text: 'Estratégico'
        },
        {
          value: 'S',
          text: 'De Soporte'
        }
      ],
      rules: {
        required: value => !!value || "Required.",
      },
      showEditProcessModal: false,
      loading: false,
      addProcessValid: false,
      alert: false,
      process_type_read_only: false,
      edit_or_new: '',
      showProcessRoles: false,
      alertRoles: false,
      editProcessPermissionsValid: false,
      validPermissionId: false
    }
  },
  computed: mapState(['sitePath']),
  mounted: function(){
      this.initGraph();
      this.getProcesses();
      this.getRoles();
      this.getDepartments();
  },
  methods: {
    async getRoles() {
      await Roles.get(this.sitePath)
        .then(response => {
          this.allRoles = []
          for (var role of response.results) {
            this.allRoles.push({ value: role.id, text: role.name })
          }
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    async getDepartments() {
      this.loading = true
      await this.$http
        .get(
          this.$base + '/api/v1' + this.$session.get('site') + '/department/',
        )
        .then(response => {
          this.allDepartments = []
          for (var dep of response.data['results']) {
            this.allDepartments.push({ value: dep.id, text: dep.name })
          }
          this.loading = false
        })
        .catch(err => {
          this.render_form_errors(err)
      })
    },
    addProcessForm: function(standard_id, parent_id) {
      this.message = ''
      this.current_standard_id = standard_id
      // this.updateStandardAspects()
      this.edit_process = {}
      this.edit_process.standard = standard_id
      this.edit_process.parent = parent_id
      this.edit_process.responsible_roles = new Array()
      this.edit_process.creator_roles = new Array()
      this.edit_process.reader_roles = new Array()
      this.edit_process.editor_roles = new Array()
      this.edit_process.process_type = null
      this.process_entries = new Array()
      // this.$refs.addmodalProcess.show()
      this.process_type_read_only = false
      this.edit_or_new = 'New'
      this.showEditProcessModal = true
    },
    async addProcess(evt) {
      if (evt) evt.preventDefault()
      this.loading = true
      this.message = ''
      await this.$http
        .post(
          this.$base + '/api/v1' + this.$session.get('site') + '/process/',
          this.edit_process,
        )
        .then(() => {
          // this.$refs.addmodalProcess.hide()
          this.showEditProcessModal = false
          this.showProcessRoles  = false
          this.getProcesses()
          this.loading = false
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    async getProcesses() {
      this.loading = true
      await this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/process/')
        .then(response => {
          this.processes = response.data['results']
          if (this.edit_process) {
            for (var i = 0; i < this.processes.length; i++) {
              var proc = this.processes[i]
              if (this.edit_process.id == proc.id) {
                this.edit_process = proc
              }
            }
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    showDetails: function(id){
      this.$router.push({ name: 'subprocess', query: { id: id }});
    },
    initGraph() {

        this.graph = new MxGraph(this.$refs.container);

        var model = this.graph.getModel();

        var style = this.graph.getStylesheet().getDefaultVertexStyle();
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_SWIMLANE;
        style[mxConstants.STYLE_VERTICAL_ALIGN] = "middle";
        style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "white";
        style[mxConstants.STYLE_FONTSIZE] = 30;
        style[mxConstants.STYLE_STARTSIZE] = 80;
        style[mxConstants.STYLE_HORIZONTAL] = false;
        style[mxConstants.STYLE_FONTCOLOR] = "black";
        style[mxConstants.STYLE_STROKECOLOR] = "black";
        style[mxConstants.STYLE_FILLCOLOR] = "lightblue";
        style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "none";

        style = mxUtils.clone(style);
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE;
        style[mxConstants.STYLE_FONTSIZE] = 15;
        style[mxConstants.STYLE_ROUNDED] = true;
        style[mxConstants.STYLE_HORIZONTAL] = true;
        style[mxConstants.STYLE_VERTICAL_ALIGN] = "middle";
        delete style[mxConstants.STYLE_STARTSIZE];
        style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "none";
        style[mxConstants.STYLE_FILLCOLOR] = "lightblue";
        this.graph.getStylesheet().putCellStyle("process", style);

        if (this.graph.isEnabled())
        {
            this.graph.isPool = function(cell)
            {
                var model = this.getModel();
                var parent = model.getParent(cell);

                return parent != null && model.getParent(parent) == model.getRoot();
            };
        }

        new mxSwimlaneManager(this.graph);

        mxEvent.disableContextMenu(document.body);

        var layout = new mxStackLayout(this.graph, false);
        layout.resizeParent = true;
        layout.fill = true;
        layout.isVertexIgnored = function(vertex)
        {
            return !this.graph.isSwimlane(vertex);
        }

        var layoutMgr = new mxLayoutManager(this.graph);
        layoutMgr.getLayout = function(cell)
        {
            if (!model.isEdge(cell) && this.graph.getModel().getChildCount(cell) > 0 &&
                (model.getParent(cell) == model.getRoot() || this.graph.isPool(cell)))
            {
                layout.fill = this.graph.isPool(cell);

                return layout;
            }

            return null;
        };

        let component = this
        this.graph.popupMenuHandler.factoryMethod = function(menu, cell)
            {
                if(!this.graph.isPool(cell) && !this.graph.isSwimlane(cell) && cell != null)
                {
                    menu.addItem('Show Details', require('../../assets/menu/search.png'), function(){
                        component.showDetails(cell.id)
                    });

                    menu.addItem('Edit Process', require('../../assets/menu/edit.png'), function()
                    {
                        component.editProcessForm(cell.id)
                    });

                    menu.addItem('Delete Process', require('../../assets/menu/delete.png'), function()
                    {
                        component.deleteProcess(cell.id)
                    });

                    menu.addItem('Process Permissions', require('../../assets/menu/permission.png'), function()
                    {
                        component.editProcessForm(cell.id, 'permissions');
                    });
                }
            };

        this.graph.addListener(mxEvent.DOUBLE_CLICK, function (sender, evt) {

            var cell = evt.getProperty("cell");
            if (cell != null && (!sender.isPool(cell) && !sender.isSwimlane(cell))) {
                component.showDetails(cell.id)
            }
            evt.consume();
        });



        this.parent = this.graph.getDefaultParent();

        this.graph.getModel().beginUpdate();
        try {
            this.graph_standard = this.graph.insertVertex(this.parent,null, this.standard.name, 0,0,1000,0);
            this.graph_standard.setConnectable(false);

            this.graph_estrategico = this.graph.insertVertex(this.graph_standard,null,"Estratégico",0,0,1000,180);
            this.graph_estrategico.setConnectable(false);

            this.graph_clave = this.graph.insertVertex(this.graph_standard,null,"Clave",0,0,1000,180);
            this.graph_clave.setConnectable(false);

            this.graph_deapoyo = this.graph.insertVertex(this.graph_standard,null,"De Soporte",0,0,1000,180);
            this.graph_deapoyo.setConnectable(false);
        } finally {
            this.graph.getModel().endUpdate();
            this.graph.setEnabled(false);
        }
    },
    
    async editProcessForm(qprocess_id, dest) {
      this.loading = true
      this.message = ''
      await this.$http
        .get(
          this.$base +
              '/api/v1' +
              this.$session.get('site') +
              '/process/' +
              qprocess_id +
              '/',
          )
        .then(response => {
          this.edit_process = response.data
          this.current_standard_id = this.edit_process.standard
          // this.updateStandardAspects()
          this.loading = false
          this.process_type_read_only = true
          if (dest == 'permissions'){
            // this.$refs.permissionsModal.show()
            this.showProcessRoles = true
          } 
          else {
            this.updateProcessEntriesList(
              this.edit_process.process_type, 
              this.edit_process.id
            )
            this.edit_or_new = 'Edit'
              // this.$refs.editmodalProcess.show()
              this.showEditProcessModal = true
          }
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    async editProcess(evt) {
      if (evt) evt.preventDefault()
      this.loading = true
      this.message = ''
      await this.$http.put(
        this.$base +
          '/api/v1' +
          this.$session.get('site') +
          '/process/' +
          this.edit_process.id +
          '/',
        this.edit_process,
      )
      .then(() => {
        this.loading = false
        this.getProcesses()
        this.showEditProcessModal = false
      })
      .catch(err => {
        this.render_form_errors(err)
      })
    },
    async deleteProcess(id) {
      if (confirm('Are you sure you want to delete this process?')) {
      this.loading = true
      this.message = ''
      await this.$http
        .delete(
          this.$base +
          '/api/v1' +
          this.$session.get('site') +
          '/process/' +
          id +
          '/',
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
      }
    },
    async deletePermission(id) {
        // var pos = -1
        // for (pos = 0; pos < this.edit_process.qprocesspermission_set.length; pos++) {
        //     if (this.edit_process.qprocesspermission_set[pos].id == id) break
        // }
        // if (pos >= 0) this.edit_process.qprocesspermission_set.splice(pos, 1)
      if (confirm('Are you sure you want to delete this process role?')) {
        this.loading = true
        this.message = ''
        await this.$http
          .delete(
            this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/processpermission/' +
            id +
            '/',
          )
          .then(() => {
            this.loading = false
            this.getProcesses()
          })
          .catch(err => {
            this.render_form_errors(err)
          })
      }
    },
    async addProcessPermission(evt) {
      if (evt) evt.preventDefault()

      if (!this.newPermission.permission_id) {
        this.message = "Permission ID couldn't be empty"
        return
      }
      this.loading = true
      this.message = ''
      this.newPermission.process = this.edit_process.id
      await this.$http
        .post(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/processpermission/',
          this.newPermission,
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
          this.newPermission = {}
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    onProcessTypeChange: function(evt){
        this.updateProcessEntriesList(evt)
    },
    updateProcessEntriesList(process_type, id){
      this.process_entries = []
      this.processes.filter(p => p.parent == null && p.process_type == process_type && p.id != id).forEach(pe => {
            this.process_entries.push({value: pe.id, text: pe.name})
      })
    },
    clearEditProcess: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editProcess.resetValidation()
      this.currentMenu = {}
    },
    closeProcessForm: function() {
      this.$refs.editProcess.reset()
      this.message = '';
      this.alert = false;
      this.showEditProcessModal = false
      this.edit_process = {}
    },
    clearEditProcessPermissions: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editProcessPermissions.resetValidation()
      this.currentMenu = {}
    },
    closeProcessPermissionsForm: function() {
      this.$refs.editProcessPermissions.reset()
      this.message = '';
      this.alert = false;
      this.showProcessRoles = false
      this.edit_process = {}
    },
    validatePermissionId: function(value){
      if ( !value ) {
        this.validPermissionId = false
        return 'Could not be empty'
      }
      var v = true
      this.validPermissionId = true
      // for (var permission in this.edit_process.qprocesspermission_set)
      var permissions = this.edit_process.qprocesspermission_set
      var permission = null
      for (var i=0; i<permissions.length; i++){
        permission = this.edit_process.qprocesspermission_set[i]
        if (value == permission.permission_id){
          this.validPermissionId = false
          v = 'Duplicated'
          break
        }
      }
      return v
    },
  },
  watch: {
    processes(newValue, oldValue){
        this.graph.getModel().beginUpdate();

        var parents_old = oldValue.filter(x => x.parent == null && x.standard == this.standard.id);
        parents_old.forEach(p => {
                this.graph.getModel().remove(this.graph.getModel().getCell(p.id))
        })

        var parents = newValue.filter(x => x.parent == null && x.standard == this.standard.id);

        try {
            var xc = 100,
                xe = 100,
                xs = 100;
            parents.forEach(p => {
                if(p.standard == this.standard.id){
                    if(p.process_type === 'C'){
                        this.graph.insertVertex(this.graph_clave, p.id, p.name, xc, 60, p.name.length * 9, 50, 'process');
                        xc = xc + p.name.length * 9 + 50;
                    }
                    if(p.process_type === 'E'){
                        this.graph.insertVertex(this.graph_estrategico, p.id, p.name, xe, 60, p.name.length * 9, 50, 'process');
                        xe = xe + p.name.length * 9 + 50;
                    }
                    if(p.process_type === 'S'){
                        this.graph.insertVertex(this.graph_deapoyo, p.id, p.name, xs, 60, p.name.length * 9, 50, 'process');
                        xs = xs + p.name.length * 9 + 50;
                    }
                }
            });

            // Adding entries
            parents.forEach(p => {
                if(p.process_entries.length > 0)
                {
                    p.process_entries.forEach(pe => {
                        var cellS = this.graph.getModel().getCell(String(pe))
                        var cellD = this.graph.getModel().getCell(String(p.id))
                        this.graph.insertEdge(this.parent, null, "", cellS, cellD);
                    });
                }
            });
        }
        finally{
            this.graph.getModel().endUpdate();
        }
    }
  }
};
</script>


<style lang="scss">
  @import "@/sass/processmap.scss";
  @import '@/sass/modalform.scss';
</style>
